<template>
    <div>
      <div 
        v-for="vwList in categorizedVwList" 
        :key="vwList.index" 
        class="mb-6"
      >
        <VwTestCategoryColumnCard
          :category-name="getCategoryNameByLanguage(vwList.categoryNames)"
          :test-node-list="vwList.testNodeList"
          :use-new-styling="useNewStyling"
          :select-prop="selectProp"
          :is-not-allowed-select-prop="isNotAllowedSelectProp"
          :order-test-support-obj="orderTestSupportObj"
        />
      </div>
    </div>
</template>

<script>
import { LANGUAGE_MAP } from "@/utils/const";
import VwTestCategoryColumnCard from "./VwTestCategoryColumnCard.vue";
import { mapState } from "vuex";
export default {
  components: {
    VwTestCategoryColumnCard
  },
  props: {
    categorizedVwList: {
      type: Array,
      default: () => []
    },
    useNewStyling: {
      type: Boolean,
      default: false
    },
    selectProp: {
      type: String,
      default: "isSelect"
    },
    isNotAllowedSelectProp: {
      type: String,
      default: "isNotAllowedSelect"
    },    
    orderTestSupportObj: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState(["language"]),
  },
  data() {
    return {}
  },
  methods: {
    getCategoryNameByLanguage(categoryNames) {
      let language = LANGUAGE_MAP[this.language];
      return categoryNames[language] || categoryNames.english;
    }
  }
}
</script>